import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ExerciseSelectorScreen from './screens/ExerciseSelectorScreen';
import VideoUploadScreen from './screens/VideoUploadScreen';
import AnalysisResultScreen from './screens/AnalysisResultScreen';
import OverviewScreen from './screens/OverviewScreen';
import ErrorBoundary from './screens/ErrorBoundary';

// #2 — fade-in on every route change
function AnimatedRoutes() {
  const location = useLocation();
  return (
    <div key={location.pathname} className="screen-enter">
      <Routes location={location}>
        <Route path="/"         element={<ExerciseSelectorScreen />} />
        <Route path="/upload"   element={<VideoUploadScreen />} />
        <Route path="/overview" element={<OverviewScreen />} />
        <Route path="/result"   element={<AnalysisResultScreen />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <div style={{
        maxWidth: '500px',
        margin: '0 auto',
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      }}>
        <ErrorBoundary>
          <AnimatedRoutes />
        </ErrorBoundary>
      </div>
    </Router>
  );
}
